/**
 * Dropdown panels of the top header (view as, language, user, notifications).
 *
 * T-21: they were `absolute right-0` under their own button; at 390 px those buttons sit in
 * the middle of the header, so a 224-320 px panel opened past the LEFT edge of the screen.
 * Below `sm` the panel is fixed under the header at full width (12 px gutters) and scrolls
 * inside; from `sm` up it keeps the original anchored position and its width class.
 */
export const HEADER_MENU_PANEL =
  'fixed inset-x-3 top-[4.5rem] max-h-[calc(100dvh-5.5rem)] overflow-y-auto sm:absolute sm:inset-x-auto sm:top-auto sm:right-0 sm:mt-2 sm:max-h-none sm:overflow-visible bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-800 py-2 animate-fadeIn z-[250]';

/** Vertical padding of a menu option: 44 px touch target on phones, compact from `sm` up. */
export const HEADER_MENU_ITEM_PY = 'py-3.5 sm:py-2';
